<template>
	<div
		@click="selectTreatmentSession"
		@keyup.enter="selectTreatmentSession"
		class="list-group-item"
		tabindex="0"
		role="link"
	>
		<Avatar
			class="avatar float-left mr-4 mb-3 lg:mb-0"
			:userId="clinicalItem.student"
			v-if="isTeacher"
		/>
		<p class="mb-1 mt-1 font-bold" v-if="isTeacher">
			{{ clinicalItem.student_displayname }}

			<span
				class="badge badge-pill badge-secondary mr-1 ml-1 mb-1"
				v-if="!clinicalItem.isLocked">
					{{ $t("not-marked") }}
			</span>
			<span class="badge badge-pill badge-success mr-1 ml-1 mb-1" v-if="clinicalItem.isLocked">
				{{ $t("marked") }}
			</span>
			<span
				class="badge badge-pill badge-danger mr-1 ml-1 mb-1"
				v-if="Number(clinicalItem.patientAttendance) >= 2">
				{{ $t("patient-did-not-attend") }}
			</span>
			<span
				class="badge badge-pill badge-success mr-1 ml-1 mb-1"
				v-if="clinicalItem.hasPatientFeedback">
				{{ $t("patient-feedback") }}
			</span>
		</p>
		<p class="mb-1 mt-1 font-bold" v-if="!isTeacher">
			{{ $t("id-colon") }} {{ clinicalItem.id }}

			<span
				class="badge badge-pill badge-secondary mr-1 ml-1 mb-1"
				v-if="!clinicalItem.isLocked">
					{{ $t("not-marked") }}
			</span>
			<span class="badge badge-pill badge-success mr-1 ml-1 mb-1" v-if="clinicalItem.isLocked">
				{{ $t("marked") }}
			</span>
			<span
				class="badge badge-pill badge-danger mr-1 ml-1 mb-1"
				v-if="Number(clinicalItem.patientAttendance) >= 2">
				{{ $t("patient-did-not-attend") }}
			</span>
			<span
				class="badge badge-pill badge-success mr-1 ml-1 mb-1"
				v-if="clinicalItem.hasPatientFeedback">
				{{ $t("patient-feedback") }}
			</span>
		</p>

		<ul class="list-bare" style="overflow: hidden">
			<template v-for="participationType in this.$config.getValue('participationTypes')">
				<li
					class="mr-3 float-lg-left text-sm"
					v-bind:key="participationType.id"
					v-if="participationType.id == clinicalItem.typeId"
				>
					{{ participationType.name }}
				</li>
			</template>
			<li class="mr-3 float-lg-left text-sm">{{ clinicalItem.clinicName }}</li>
			<li class="mr-3 float-lg-left text-sm" v-if="isTeacher">
				{{ $t("id-colon") }} {{ clinicalItem.id }}
			</li>
			<li class="mr-3 float-lg-left text-sm">
				{{ $datetime.getLocaleStringFromTimeStamp(clinicalItem.treatmentTimestamp) }}
			</li>
			<li class="mr-3 float-lg-left text-sm">
				{{ $t("teacher-colon") }} {{ clinicalItem.teacher_displayname }}
			</li>
			<li
				class="float-lg-left text-sm"
				v-if="clinicalItem.chairNumber && this.$config.getValue('showchairnumber')"
			>
				{{ $t("chair-no-colon") }} {{ clinicalItem.chairNumber }}
			</li>
		</ul>
	</div>
</template>

<script>
import Avatar from "./Avatar.vue";
export default {
	name: "ClinicalItem",
	components: {
		Avatar,
	},
	props: ["clinicalItem"],
	computed: {
		isTeacher() {
			return this.$UserSession.hasPriv.call(this, "MARK_TREATMENTSESSIONS");
		},
		avatarStyle() {
			const url = `${this.$settings.APIBaseURL}/asset/avatar/${
				this.clinicalItem.student
			}?username=${this.$UserSession.getValue(
				"username"
			)}&authToken=${this.$UserSession.getValue("authToken")}`;

			return `background-image: url(${url})`;
		},
	},
	methods: {
		selectTreatmentSession() {
			this.$store.commit("showBlockingSpinner");
			this.$router.push(`/clinical/treatmentsession/${this.clinicalItem.id}`);
		},
	},
};
</script>
